import { customerInformationAndDeclaration as TC } from './customerInformationAndDeclaration';

interface CustomerDeclarationProps {
  className?: string;
}

function createListNumber(indexes: number[], isListOrder = false) {
  return (
    indexes.reduce((acc, index) => {
      return !isListOrder ? acc + `${index + 1}.` : '⁃';
    }, '') + ' '
  );
}

function renderParagraphs(paragraphs: string[], indexes: number[], hasOrder?: boolean, isListOrder?: boolean) {
  return paragraphs?.map((paragraphs, paragraphsIndex) => (
    <li key={`paragraph-${paragraphsIndex}`} className={'mb-3'}>
      {hasOrder && createListNumber([...indexes, paragraphsIndex], isListOrder)}
      {paragraphs}
    </li>
  ));
}

// TODO: Refactor this to avoid using dangerouslySetInnerHTML -
// it's not going to cause XSS because the text is static,
// but it could if copied somewhere else in the codebase
export const CustomerDeclaration = ({ className }: CustomerDeclarationProps) => {
  const { title, subTitle, sections, afterwards, warning, footer } = TC;

  return (
    <div className={className}>
      <h1 className={'title text-center'}>{title}</h1>
      {!Array.isArray(subTitle) ? (
        <p className={'sub-title'}>{subTitle}</p>
      ) : (
        <div className={'sub-title'}>
          {subTitle.map((subTitle, index) => (
            <p key={index} dangerouslySetInnerHTML={{ __html: subTitle }}></p>
          ))}
        </div>
      )}

      <ol>
        {sections.map(({ title, paragraphs }, sectionIndex) => {
          return (
            <li className={'marker:font-extrabold'} key={sectionIndex}>
              {title && <h3 className={'font bold mb-2'}>{title}</h3>}
              <ul>
                {paragraphs.map(
                  ({ text, hasSubParagraphsOrder, isSubParagraphsListOrder, subParagraphs, style }, paragraphIndex) => (
                    <li key={`paragraph-${paragraphIndex}`} className={`mb-3 ${style?.join(' ')}`}>
                      {/* {hasOrder && createListNumberHandler([sectionIndex, paragraphIndex], isListOrder)} */}
                      <p dangerouslySetInnerHTML={{ __html: text }}></p>
                      {subParagraphs && (
                        <ol className={`ml-4 list-none`}>
                          {renderParagraphs(
                            subParagraphs,
                            [sectionIndex, paragraphIndex],
                            hasSubParagraphsOrder,
                            isSubParagraphsListOrder,
                          )}
                        </ol>
                      )}
                    </li>
                  ),
                )}
              </ul>
            </li>
          );
        })}
      </ol>

      {Array.isArray(afterwards) && (
        <div className={'mt-4'}>
          {afterwards.map(({ title, subTitle, paragraphs }, index) => (
            <div key={index}>
              <h3 className={'font bold mb-2'}>{title}</h3>
              {subTitle && (
                <div className={'sub-title'}>
                  {Array.isArray(subTitle) ? (
                    subTitle.map((subTitle, index) => (
                      <p key={index} dangerouslySetInnerHTML={{ __html: subTitle }}></p>
                    ))
                  ) : (
                    <p dangerouslySetInnerHTML={{ __html: subTitle }}></p>
                  )}
                </div>
              )}
              <ul>
                {paragraphs.map(({ text }, paragraphIndex) => (
                  <li key={`paragraph-${paragraphIndex}`} className={'mb-3'}>
                    <p dangerouslySetInnerHTML={{ __html: text }}></p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {warning && (
        <div className={'mt-4 font-bold text-lg text-center'}>
          {warning.map((warning, index) => (
            <p key={index}>{warning}</p>
          ))}
        </div>
      )}

      {footer && (
        <div className={'mt-4 text-xs text-center'}>
          {footer.map((footer, index) => (
            <p key={index}>{footer}</p>
          ))}
        </div>
      )}
    </div>
  );
};
